/**
 *
 *  ScrollToTopOnMount
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 14/04/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTopOnMount() {
  const location = useLocation();

  useEffect(() => {
    // window.scrollTo(0, 0);

    const hash = window.location.hash;

    if (hash) {
      const element = document.getElementById(hash.substring(1)); // Remove the '#' from the hash
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // Scroll to the element smoothly
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
}
